(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["eliseamour-duo-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('eliseamour-duo-offer')) {
    customElements.define(
      'eliseamour-duo-offer',
      class extends HTMLElement {
        connectedCallback() {
          const productSection = this.closest('.shopify-section');
          if (productSection) {
            productSection.classList.add('ea-product-page');
            const productHandle = this.dataset.productHandle;
            if (productHandle) productSection.classList.add('ea-product-page--' + productHandle);
          }

          this.addEventListener('change', (event) => {
            if (event.target.matches('[data-ea-pack]')) this.updateSelection();
          });

          this.addEventListener('input', (event) => {
            if (event.target.matches('[data-ea-initials]')) {
              const maxLength = Number(event.target.maxLength) || 2;
              event.target.value = event.target.value.replace(/[^a-zA-ZÄÖÜäöü]/g, '').toUpperCase().slice(0, maxLength);
            }

            if (event.target.matches('[data-ea-engraving]')) {
              event.target.value = event.target.value.replace(/[^a-zA-ZÄÖÜäöüßẞ0-9]/g, '').slice(0, 8);
            }
          });

          this.updateSelection();

          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.updateSelection(), { once: true });
          }
        }

        updateSelection() {
          const selected = this.querySelector('[data-ea-pack]:checked');
          const quantity = selected ? Number(selected.value) : 1;
          const secondWrap = this.querySelector('[data-ea-second-wrap]');
          const secondInputs = this.querySelectorAll('[data-ea-second-field]');

          if (secondWrap) secondWrap.hidden = quantity !== 2;
          secondInputs.forEach((input) => {
            input.disabled = quantity !== 2;
            input.required = quantity === 2;
          });

          const form = document.getElementById(this.dataset.formId);
          const quantityInput = form ? form.querySelector('input[name="quantity"]') : null;

          if (quantityInput) {
            quantityInput.value = String(quantity);
            quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
            quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
            const productDetails = this.closest('.product-details');
            if (productDetails) productDetails.classList.add('ea-pack-active');
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
